import * as swcHelpers from '@swc/helpers';
import { uninitState, idleState, failedState, loadingState, successState } from '@grandvisionhq/state';
import { UPDATE_OPT_INS_FAILED, UPDATE_OPT_INS_SUCCESS, UPDATE_OPT_INS, TOGGLE_OPT_INS, FETCH_OPT_INS_FAILED, FETCH_OPT_INS_SUCCESS, FETCH_OPT_INS } from './actions.js';

/**
 * @deprecated use the new GQL hook
 * packages/auth/src/OptIns/hooks/use-available-opt-ins.ts
 */ const initialState = {
    optInsOnServer: uninitState(),
    changedOptIns: {},
    updateOptInsCall: idleState()
};
/**
 * @deprecated use the new GQL hook
 * packages/auth/src/OptIns/hooks/use-available-opt-ins.ts
 */ function optInsReducer(state = initialState, action) {
    switch(action.type){
        case FETCH_OPT_INS:
            return swcHelpers.objectSpread({}, state, {
                optInsOnServer: loadingState()
            });
        case FETCH_OPT_INS_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                optInsOnServer: successState(action.payload)
            });
        case FETCH_OPT_INS_FAILED:
            return swcHelpers.objectSpread({}, state, {
                optInsOnServer: failedState(action.error)
            });
        case TOGGLE_OPT_INS:
            return swcHelpers.objectSpread({}, state, {
                changedOptIns: swcHelpers.objectSpread({}, state.changedOptIns, action.payload)
            });
        case UPDATE_OPT_INS:
            return swcHelpers.objectSpread({}, state, {
                updateOptInsCall: loadingState()
            });
        case UPDATE_OPT_INS_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                updateOptInsCall: idleState()
            });
        case UPDATE_OPT_INS_FAILED:
            return swcHelpers.objectSpread({}, state, {
                updateOptInsCall: failedState(action.error)
            });
        default:
            return state;
    }
}

export { initialState, optInsReducer };
//# sourceMappingURL=reducer.js.map
